module.exports = __webpack_public_path__ + "img/minus.7c6a40da.svg";